export default "__VITE_ASSET__BI0iP$Sh__"